import { render, staticRenderFns } from "./informations-marche.vue?vue&type=template&id=2860d31e&scoped=true&"
import script from "./informations-marche.vue?vue&type=script&lang=ts&"
export * from "./informations-marche.vue?vue&type=script&lang=ts&"
import style0 from "./informations-marche.vue?vue&type=style&index=0&id=2860d31e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860d31e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
